export default "__VITE_ASSET__VTQuEnkQ__"